import { SubscriptionSummary } from "components/SubscriptionSummary";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useGetTeamMembersQuery } from "store/apis/teamSetting";
import { Loader } from "components/DesignSystem/Loader/Loader";
import { ProductGroup } from "store/apis/products";
import { useDispatch } from "react-redux";
import { setOpenSeatManageModal } from "store/slices/subscriptionSummary";

const BillingSubscription = ({
  taxProduct,
  isSearch,
}: {
  taxProduct: ProductGroup;
  isSearch?: boolean;
}) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const {
    data = {
      active_group_users_count: 0,
      available_seats: 0,
      extra_seat_amount: 0,
      free_seats: 0,
    },
    isLoading: teamMemberLoading,
    isSuccess,
  } = useGetTeamMembersQuery({ groupId }, { skip: !groupId });
  const dispatch = useDispatch();

  const extraSeats =
    data.active_group_users_count + data.available_seats - data.free_seats;

  if (teamMemberLoading || !isSuccess) {
    return <Loader />;
  }

  return (
    <div className="">
      <SubscriptionSummary
        freeSeats={data.free_seats}
        extraSeats={extraSeats}
        setShowSeatManage={() => dispatch(setOpenSeatManageModal(true))}
        activeSeats={data.active_group_users_count}
        tax={taxProduct}
        isSearch={isSearch}
      />
    </div>
  );
};

export default BillingSubscription;
